import m from './module';

import agreementCheckboxField from './agreementCheckboxField/agreementCheckboxField.component';
import dateField from './dateField/dateField.component';
import dateTimeField from './dateTimeField/dateTimeField.component';
import durationField from './durationField/durationField.component';
import fileUploadField from './fileUploadField/fileUploadField.component';
import moneyField from './moneyField/moneyField.component';
import multiSelectCheckboxField from './multiSelectCheckboxField/multiSelectCheckboxField.component';
import numericField from './numericField/numericField.component';
import radioField from './radioField/radioField.component';
import radioFieldWithNumeric from './radioFieldWithNumeric/radioFieldWithNumeric.component';
import selectField from './selectField/selectField.component';
import selectFieldSearchable from './selectFieldSearchable/selectFieldSearchable.component';
import signatureField from './signatureField/signatureField.component';
import textAreaField from './textAreaField/textAreaField.component';
import textField from './textField/textField.component';
import timeField from './timeField/timeField.component';
import yesNoField from './yesNoField/yesNoField.component';
import formulaField from './formulaField/formulaField.component';
import rankField from './rankField/rankField.component';
import hyperlinkField from './hyperlinkField/hyperlinkField.component';
import phonenumberField from './phoneField/phoneField.component';

export const components = {
  agreementCheckboxField,
  dateField,
  dateTimeField,
  durationField,
  fileUploadField,
  moneyField,
  multiSelectCheckboxField,
  numericField,
  radioField,
  radioFieldWithNumeric,
  selectField,
  selectFieldSearchable,
  signatureField,
  textAreaField,
  textField,
  timeField,
  yesNoField,
  formulaField,
  rankField,
  hyperlinkField,
  phonenumberField,
};

export const componentMap = {
  'FIELD_TEXT': 'textField',
  'FIELD_YES_NO': 'yesNoField',
  'FIELD_MULTISELECT': 'multiSelectCheckboxField',
  'FIELD_IMAGE_UPLOAD': 'fileUploadField',
  'FIELD_IMAGE_UPLOAD_MULTIPLE': 'fileUploadField',
  'FIELD_MONEY': 'moneyField',
  'FIELD_DATE': 'dateField',
  'FIELD_DATETIME': 'dateTimeField',
  // 'FIELD_SELECT': 'selectField',
  // 'FIELD_SELECT': 'radioField',
  'FIELD_SELECT': 'selectFieldSearchable',
  'FIELD_SELECT_WITH_NUMERIC_EQUIVALENT': 'radioFieldWithNumeric',
  'FIELD_SELECT_RADIO': 'radioField',
  'FIELD_TEXTAREA': 'textAreaField',
  'FIELD_TIME': 'timeField',
  'FIELD_SIGNATURE_CAPTURE': 'signatureField',
  'FIELD_AGREEMENT_CHECKBOX': 'agreementCheckboxField',
  'FIELD_DURATION': 'durationField',
  'FIELD_FLOAT1': 'numericField',
  'FIELD_FLOAT2': 'numericField',
  'FIELD_INTEGER': 'numericField',
  'FIELD_FORMULA': 'formulaField',
  'FIELD_RANK': 'rankField',
  'FIELD_HYPERLINK': 'hyperlinkField',
  'FIELD_PHONENUMBER': 'phonenumberField',
  'default': 'textField',
};

export default function componentNameForFieldType(fieldType) {
  let componentName = componentMap[fieldType.defined_as] || componentMap.default;
  return componentName;
};

for (let componentName of Object.keys(components)) {
  m.component(componentName, components[componentName]);
}
